export const USER_TYPE_LS_KEY= 'user_type'
export const VERSION_LS_KEY= 'version'
export const LANGUAGE_LS_KEY = 'language';